module.exports = {"330726001":"浦南街道","330726002":"仙华街道","330726003":"浦阳街道","330726101":"黄宅镇","330726102":"白马镇","330726103":"郑家坞镇","330726104":"郑宅镇","330726105":"岩头镇","330726106":"檀溪镇","330726107":"杭坪镇","330726200":"大畈乡","330726201":"中余乡","330726202":"前吴乡","330726203":"花桥乡","330726204":"虞宅乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330726.json
// module id = 1000
// module chunks = 0